import React from "react";
import { Link } from "gatsby";
import { formatFuzzyDate } from "./../../modules/time";
import { StepheaderDiv, StepBodyDiv } from "./elements";

const objectTypes = {
  timelineEntry: "Timeline entry",
  objectPdf: "PDF",
  objectImage: "Image",
};

const slugs = {
  timelineEntry: "event",
  objectPdf: "pdf",
  objectImage: "image",
};

export const StepHeader = ({ itemData }) => {
  const {
    title,
    _type,
    date,
    dateApproximateness,
    endDate,
    endDateApproximateness,
    _id,
  } = itemData;
  const isRange = Boolean(endDate);
  return (
    <StepheaderDiv>
      <h2>
        {title}
        <em>
          <Link to={`/${slugs[_type]}/${_id}`}>{objectTypes[_type]}</Link>
        </em>
      </h2>
      <h3>
        {isRange
          ? !date
            ? null
            : `${formatFuzzyDate(date, dateApproximateness)}–${formatFuzzyDate(
                endDate,
                endDateApproximateness || dateApproximateness
              )}`
          : formatFuzzyDate(date, dateApproximateness)}
      </h3>
    </StepheaderDiv>
  );
};

export const StepBody = ({ body, comment }) => (
  <StepBodyDiv>
    {body}
    {comment}
  </StepBodyDiv>
);
